import React, { type ReactNode } from 'react';
import { useSiteConfig } from 'src/react/config';
import { DownloadSelectionProvider } from 'src/react/shared/molecules/DownloadSelection';

// Downstream code checks useDownloadSelection() for null, never the site.
const DownloadSelectionAdapter = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const { batchDownload } = useSiteConfig();

  if (!batchDownload.available) {
    return children;
  }

  return <DownloadSelectionProvider>{children}</DownloadSelectionProvider>;
};

export default DownloadSelectionAdapter;
